"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gameHeight = 180;
exports.default = gameHeight;
